import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default function useExportRiskMap() {
  const LEVELS = [
    { key: 'Crítico', min: 20, max: 25, color: '#823535' },
    { key: 'Muy Alto', min: 15, max: 19, color: '#C00000' },
    { key: 'Alto', min: 10, max: 14, color: '#ED7D31' },
    { key: 'Medio', min: 5, max: 9, color: '#FFC000' },
    { key: 'Bajo', min: 1, max: 4, color: '#70AD47' },
  ]

  function getRiskLevel(value) {
    for (const level of LEVELS) {
      if (value >= level.min && value <= level.max) return level
    }
    return LEVELS[4]
  }

  function hexToArgb(hex) {
    return 'FF' + hex.replace('#', '')
  }

  const exportToExcel = (matrixData, summaryTable, riskType) => {
    const wb = XLSX.utils.book_new()

    // Sheet 1: Matriz de Valores
    const valuesData = []
    valuesData.push(['MAPA DE RIESGOS — Probabilidad × Impacto'])
    valuesData.push([`Tipo: Riesgo ${riskType === 'inherent' ? 'Inherente' : 'Residual'}`])
    valuesData.push([])
    valuesData.push(['Valoración del Riesgo (P×I)', 'I=1 Nulo/Muy Bajo', 'I=2 Bajo', 'I=3 Medio', 'I=4 Alto', 'I=5 Muy Alto'])

    for (let p = 1; p <= 5; p++) {
      const row = [`P=${p}`]
      for (let i = 1; i <= 5; i++) {
        row.push(p * i)
      }
      valuesData.push(row)
    }

    const wsValues = XLSX.utils.aoa_to_sheet(valuesData)
    XLSX.utils.book_append_sheet(wb, wsValues, 'Matriz Valores')

    // Sheet 2: Matriz de Contadores
    const counterData = []
    counterData.push(['Tratamientos por cuadrante (contador dinámico)'])
    counterData.push([`Tipo: Riesgo ${riskType === 'inherent' ? 'Inherente' : 'Residual'}`])
    counterData.push([])
    counterData.push(['Probabilidad \\ Impacto', 'I=1 Nulo/Muy Bajo', 'I=2 Bajo', 'I=3 Medio', 'I=4 Alto', 'I=5 Muy Alto'])

    for (let p = 1; p <= 5; p++) {
      const row = [`P=${p}`]
      for (let i = 1; i <= 5; i++) {
        const key = `${p}-${i}`
        const count = matrixData[key]?.length || 0
        row.push(count)
      }
      counterData.push(row)
    }

    const wsCounter = XLSX.utils.aoa_to_sheet(counterData)
    XLSX.utils.book_append_sheet(wb, wsCounter, 'Matriz Contadores')

    // Sheet 3: Resumen por Nivel
    const summaryData = []
    summaryData.push(['TRATAMIENTOS POR NIVEL DE RIESGO'])
    summaryData.push([])
    summaryData.push(['Nivel', 'Rango PxI', 'Cantidad', '% Del Total', 'Riesgo Promedio'])

    for (const row of summaryTable) {
      const level = LEVELS.find(l => l.key === row.level)
      const range = `${level.min}-${level.max}`
      summaryData.push([row.level, range, row.count, `${row.percentage}%`, row.avgRisk || '-'])
    }

    const wsSummary = XLSX.utils.aoa_to_sheet(summaryData)
    XLSX.utils.book_append_sheet(wb, wsSummary, 'Resumen por Nivel')

    // Sheet 4: Detalle de Tratamientos
    const detailData = []
    detailData.push(['Detalle de Tratamientos por Celda'])
    detailData.push([])
    detailData.push(['P', 'I', 'PxI', 'Nivel', 'ID Tratamiento', 'Nombre', 'EIPD Requerida'])

    for (let p = 1; p <= 5; p++) {
      for (let i = 1; i <= 5; i++) {
        const key = `${p}-${i}`
        const items = matrixData[key] || []
        for (const item of items) {
          const risk = p * i
          const level = getRiskLevel(risk)
          detailData.push([
            p,
            i,
            risk,
            level.key,
            item.treatmentId,
            item.nombre,
            item.eipdFinal ? 'Sí' : 'No',
          ])
        }
      }
    }

    const wsDetail = XLSX.utils.aoa_to_sheet(detailData)
    XLSX.utils.book_append_sheet(wb, wsDetail, 'Detalle Tratamientos')

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([wbout], { type: 'application/octet-stream' })
    const fileName = `Mapa_Riesgos_${riskType === 'inherent' ? 'Inherente' : 'Residual'}_${new Date().toISOString().slice(0, 10)}.xlsx`
    saveAs(blob, fileName)
  }

  return {
    exportToExcel,
  }
}
